import { forwardRef } from 'react';
import Icon from '../atoms/Icon';
import { DRAWER_ID } from './MobileDrawer';

interface MobileHeaderProps {
  menuOpen: boolean;
  onMenuToggle: () => void;
}

/**
 * @component MobileHeader
 * @description Mobile-only header bar with the GFS logo and a hamburger menu toggle.
 * Uses `forwardRef` so the parent can return focus to the toggle button when the drawer closes.
 * @param menuOpen - Whether the mobile navigation drawer is currently open.
 * @param onMenuToggle - Callback to toggle the drawer open/closed.
 * @param ref - Forwarded ref attached to the hamburger button for focus management.
 * @returns A header bar visible only on mobile viewports.
 */
const MobileHeader = forwardRef<HTMLButtonElement, MobileHeaderProps>(
  function MobileHeader({ menuOpen, onMenuToggle }, ref) {
    return (
      <div className="lg:hidden flex items-center justify-between px-6 pt-6 pb-2">
        <Icon name="welcome" className="w-16 h-8" alt="Grounds for Sculpture logo" decorative={false} />
        <button
          ref={ref}
          onClick={onMenuToggle}
          className="p-2"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          aria-controls={DRAWER_ID}
        >
          <svg className="w-7 h-7 text-charcoal" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    );
  }
);

export default MobileHeader;
